import $ from 'jquery';

export default class DownloadAgreement {
	constructor() {
		this.form = $('.download-agreement__form');
		this.closeButton = $('.download-agreement__close-button');
		this.tableLink = $('.utility-table-row__download-link');
		this.overlay = $('.download-agreement__overlay');
		this.downloadButton = $('.download-agreement__on-confirm');
	}

	init() {

		this.tableLink.on('click', function (event) {
			event.preventDefault();
			$(this).parents('body').css('overflow-y', 'hidden');
			$(this).parents('.support-page__utility-table-wrapper').siblings().addClass('download-agreement_show');
			const hrefLink = $(this).attr('href');
			$(this).parents('.support-page__utility-table-wrapper').siblings().children('.download-agreement__form')
				.children('.download-agreement__confirm').children('.download-agreement__on-confirm').attr('href', hrefLink);
		});

		this.closeButton.on('click', function () {
			$(this).parents('body').css('overflow-y', 'auto');
			$(this).parents('.download-agreement').removeClass('download-agreement_show');
			const checkbox = $(this).siblings('.download-agreement__confirm').children('.download-agreement__checkbox');
			if (checkbox.attr('checked', true)) {
				checkbox.removeAttr('checked');
			}
		});

		this.overlay.on('click', function () {
			$(this).parents('body').css('overflow-y', 'auto');
			$(this).parents('.download-agreement').removeClass('download-agreement_show');
		});

		this.downloadButton.on('click', function () {
			$(this).parents('.download-agreement').removeClass('download-agreement_show');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/download-agreement/index.js